import './assets/styles/epa.scss'
import template from './assets/templates/epa.html'
import star from './assets/images/star.svg'
import jQuery from 'jquery'

function action (event, widget, params) {
  let nums = [1, 2, 3, 4, 5]
  let numStars = nums.map(function (num) { return `epa_${num}` })
  let element = jQuery(jQuery.mustache(template, {
    sender: 'assistant',
    numStars: numStars,
    title: params.title,
    label: params.button_label,
    icons: {
      star: star
    }
  }))
  // widget._controls.find('textarea').prop('disabled', true).prop('placeholder', 'Encuestame!')
  widget._log(element)
  widget._input.focus()
  let stars = element.find('.wgt-action-epa-star')

  stars.click(function () {
    widget._send({
      type: 'text',
      payload: jQuery(this).attr('id')
    })
    stars.off('mouseenter mouseout click')
    element.off('mouseleave')
    // widget._controls.find('textarea').prop('disabled', false).prop('placeholder', 'Escribeme')
  })
  element.mouseleave(function () {
    element.find('.wgt-action-epa-buttons').find('path').css('fill', '#878f99')
  })

  stars.mouseenter(function (event) {
    element.find('.wgt-action-epa-buttons').find('path').css('fill', '#878f99')
    let selectedStar = jQuery(this)
    stars.each(function () {
      let curStar = jQuery(this)
      let curId = curStar.attr('id')
      if (curId <= selectedStar.attr('id')) {
        jQuery(curStar).find('path').css('fill', '#ED8A19')
      }
    })
  })
}

export default action
